<div class="d-flex flexWrap-wrap flexJustify-between mb-0075">
  <div class="select-overlay2-wrapper col__ col__lg--48"
       [ngClass]="{ 'col__lg--48' : !fullwidth }">
    <div class="ab-input-group ab-input-group--entity-type-icon">
      <div class="ab-input-group__prepend">
        <div class="ab-input-group__text">
          <i class="txt-16 fal fa-{{value ? value : 'ban'}}"
             [ngClass]="value ? 'color--blue' : 'color--gray--003'"></i>
        </div>
      </div>
      <div class="ab-input-group__field">
        <button type="button"
                #trigger="cdkOverlayOrigin"
                cdkOverlayOrigin
                (click)="openOverlay()"
                class="mimic-mat-select-field w-100 ongray"
                [ngClass]="value ? 'mimic-mat-select-field--with-label' : 'color--gray--005'">
          <label *ngIf="value">Select an icon&hellip;</label>
          <span class="d-block truncate">{{value ? value : 'Select an
            icon&hellip;'}}</span>
          <div *ngIf="value && !hideClearButton"
               class="mat-clear-field"
               (click)="onClearFieldClick($event)"
               [matTooltip]="'Clear selection'">
            <i class="fal fa-times"></i>
          </div>
          <div class="mat-select-arrow-wrapper">
            <div class="mat-select-arrow"></div>
          </div>
        </button>
        <ng-template cdkConnectedOverlay
                     (backdropClick)="closeOverlay()"
                     [cdkConnectedOverlayPush]="true"
                     [cdkConnectedOverlayHasBackdrop]="true"
                     [cdkConnectedOverlayBackdropClass]="'transparent-backdrop'"
                     [cdkConnectedOverlayHeight]="300"
                     [cdkConnectedOverlayMinHeight]="'300px'"
                     [cdkConnectedOverlayOrigin]="trigger"
                     [cdkConnectedOverlayWidth]="'300px'"
                     [cdkConnectedOverlayMinWidth]="'300px'"
                     [cdkConnectedOverlayOpen]="isOpen">
          <div class="select-overlay2">
            <div class="select-overlay2 select-overlay2__content select-overlay2__icon-content select-info">
              <button type="button"
                      class="ab-overlay-close-button"
                      (click)="closeOverlay()">
                <span><i class="fal fa-times"></i></span>
              </button>
              <div class="scrollable-quicksearch--wrapper scrollable-quicksearch--has-no-filter-btn">
                <mat-form-field class="col__ no-label m-0075 mt-0075 mb-0025">
                  <mat-icon matIconPrefix
                            fontSet="far fa-fw"
                            fontIcon="fa-magnifying-glass"
                            class="color--gray--007"></mat-icon>
                  <input matInput
                         [formControl]="iconSearchControl"
                         placeholder="Search by icon name"
                         appAutofocus
                         name="icon-search"
                         autocomplete="off">
                </mat-form-field>
                <small class="d-block color--gray m-0075 mt-0025neg txt-10">
                  All <a href="https://fontawesome.com/v5.15/icons"
                         target="_blank"
                         class="link">Font Awesome Icons (v6)</a> are supported.
                </small>
                <section tabindex="0">
                  <cdk-virtual-scroll-viewport class="scrollable-quicksearch__results scrollable-quicksearch__results--icon-results p-0050"
                                               itemSize="53"
                                               style="height:250px">
                    <div class="d-flex flexWrap-wrap"
                         *cdkVirtualFor="let iconChunk of visibleIcons">
                      <button *ngFor="let icon of iconChunk"
                            class="icon-result"
                            type="button"
                            aria-label="Select {{icon}} as entity icon"
                            [ngClass]="{'selected': icon === value}"
                            #tooltip="matTooltip"
                            [matTooltip]="icon"
                            [matTooltipTouchGestures]="'off'"
                            (focus)="tooltip.show()"
                            (blur)="tooltip.hide()"
                            (click)="onIconSelected(icon)">
                        <i class="fal fa-{{icon}}"></i>
                      </button>
                    </div>
                  </cdk-virtual-scroll-viewport>
                </section>
              </div>
            </div>
          </div>
        </ng-template>
      </div>
    </div>
  </div>
</div>
